module.exports = __webpack_public_path__ + "assets/img/news-bountiful.81bfce92.png";